module.exports = __webpack_public_path__ + "assets/img/mecha-btn-c5cfc1d1.png";